import {useEffect, useState} from "react";
import {DataPoint, Scatterplot} from "./Scatterplot";
import {InteractionData} from "./Tooltip";
import {WELLS_AMOUNT} from "../utils/consts";

interface IScatterplotBasicDemoProps {
    width: number;
    height: number;
    data?: DataPoint[];
    xFinish?: number;
    yFinish?: number;
    hovered: InteractionData | null;
    setHovered: (hovered: InteractionData | null) => void;
    wellsAmount?: number;
}
export const ScatterplotBasicDemo = ({ xFinish= 20, yFinish = 20, data, hovered, setHovered , wellsAmount}: IScatterplotBasicDemoProps) => {

    const [dims, setDims] = useState({ w: window.innerWidth * 0.92, h: window.innerHeight * 0.65 });

    useEffect(() => {
        const onResize = () => setDims({ w: window.innerWidth * 0.92, h: window.innerHeight * 0.65 });
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
      data && (
        <div style={{display: "flex", width: "100%"}}>
                <Scatterplot
                  data={data}
                  width={dims.w}
                  height={dims.h}
                  xRange={{
                      start: 0, finish:
                      xFinish
                  }}
                  yRange={{start: 0, finish: yFinish}}
                  hovered={hovered}
                  setHovered={setHovered}
                  wellsAmount={wellsAmount || WELLS_AMOUNT}
                />
        </div>
      )
    );
}
